import angular from 'angular';

angular
  .module('cxSettings')
  .controller('InvoiceTextSettingsCtrl', [
    '$rootScope',
    '$scope',
    '$translate',
    'settingsDialogsSvc',
    'flySvc',
    'data',
    '$http',
    'appUrls',
    'ModalService',
    'dialogsSvc',
    invoiceTextSettingsCtrl,
  ]);

function invoiceTextSettingsCtrl(
  $rootScope,
  $scope,
  $translate,
  settingsDialogsSvc,
  flySvc,
  data,
  $http,
  appUrls,
  ModalService,
  dialogsSvc,
) {
  var vm = this;
  vm.invoiceTexts = data;
  vm.exampleLanguage = $translate.use().split('-')[0];
  vm.languages = ['nl', 'fr', 'en'];

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };
  var generateExample = function(invoiceText) {
    if (!invoiceText) return;
    invoiceText.example = invoiceText.languages[vm.exampleLanguage] || '';
    //Todo: Replace parameters
  };

  vm.add = function() {
    settingsDialogsSvc.newInvoiceText().then(function(item) {
      if (item) {
        generateExample(item);
        vm.invoiceTexts.push(item);
      }
    });
  };

  vm.edit = function(item) {
    settingsDialogsSvc.editInvoiceText(item).then(function(result) {
      if (result) {
        angular.extend(item, result);
        generateExample(item);
      }
    });
  };
  vm.clone = function(item) {
    const newItem = angular.copy(item);
    newItem.name = '';
    delete newItem.id;
    settingsDialogsSvc.editInvoiceText(newItem).then(function(result) {
      if (result) {
        generateExample(result);
        vm.invoiceTexts.push(result);
      }
    });
  };
  vm.remove = function(item) {
    alert("Remove doesn't work yet");
  };

  vm.changeLanguage = function(lang) {
    vm.exampleLanguage = lang;
    vm.invoiceTexts.forEach(generateExample);
  };
  vm.changeLanguage(vm.exampleLanguage);

  //Listen to global language change event
  var deregistration = $rootScope.$on('$translateChangeSuccess', function() {
    vm.exampleLanguage = $translate.use().split('-')[0];
    vm.changeLanguage(vm.exampleLanguage);
  });
  $scope.$on('$destroy', deregistration);

  vm.showPlaceholders = function() {
    if (!vm.placeholders) {
      $http.get(appUrls.api + '/api/invoicetext/placeholders').then(
        function(result) {
          vm.placeholders = result.data;
          vm.showPlaceholders();
        },
        function(error) {
          flySvc.error(error.code, error.parameters);
        },
      );
      return;
    }

    ModalService.showModal({
      template: require('./dialogs/placeholderDialog.html'),
      controller: 'PlaceholderDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        placeholders: vm.placeholders,
        taskParameterPlaceholders: [],
        context: 'invoicetext',
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };

  vm.deleteInvoiceText = function(item) {
    return $http.delete(`${appUrls.api}/api/invoicetext/delete/${item.id}`).then(function() {
      var idx = vm.invoiceTexts.findIndex(x => x.id === item.id);
      if (idx >= 0) {
        vm.invoiceTexts.splice(idx, 1);
      }
      flySvc.success('msgItemRemoved');
    });
  };

  vm.delete = function(item) {
    $http.get(`${appUrls.api}/api/invoicetext/usage/${item.id}`).then(({ data }) => {
      const { relations = [], schedules = [] } = data || {};

      var hasUsage = relations.length > 0 || schedules.length > 0;
      if (hasUsage) {
        ModalService.showModal({
          template: require('./dialogs/deleteInvoiceTextConfirmDialog.html'),
          controller: 'DeleteInvoiceTextConfirmDialogCtrl',
          controllerAs: 'vm',
          locationChangeSuccess: false,
          inputs: {
            relations,
            schedules,
          },
        }).then(function(modal) {
          modal.element.modal();
          modal.element.on('hidden.bs.modal', function(e) {
            modal.element.off(e); //Remove event
            modal.element.remove(); //Remove element
          });
          modal.close.then(function(result) {
            if (result) {
              vm.deleteInvoiceText(item);
            }
          });
        });
      } else {
        dialogsSvc.showYesNo('comfirmDeleteTitle', 'confirmDeleteInvoiceText').then(function() {
          vm.deleteInvoiceText(item);
        });
      }
    });
  };
}
